export default "__VITE_ASSET__4aa42c7e__"